import { EditShareModalContextType } from '../types/EditShareModalContextType';

export const editShareModalInitValue: EditShareModalContextType = {
  data: {
    tag: '',
    isLoading: false,
  },
  actions: {
    handleCloseModal: () => {},
    handleChangeTag: (newTag: string) => {}, // eslint-disable-line no-unused-vars
    handleSave: () => {},
  },
};
